import LegalLayout, { LegalBlock } from "./LegalLayout";
import { SUPPORT_EMAIL } from "../lib/site";

const Li = ({ children }) => (
  <li className="flex gap-2"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-greenaccent" /><span>{children}</span></li>
);

const Email = () => (
  <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand hover:underline">{SUPPORT_EMAIL}</a>
);

export default function Terms() {
  return (
    <LegalLayout testid="terms-page" label="Legal" title="Terms of Service" updated="February 2026">
      <p>
        These Terms of Service ("Terms") govern your use of RenewTracker (the "Service"). By creating an account or using the Service, you agree to these Terms. If you do not agree, do not use the Service.
      </p>

      <LegalBlock num="1" heading="What RenewTracker Is — and Isn't">
        <p>RenewTracker is a reminder and tracking tool only.</p>
        <p>RenewTracker is <strong>not</strong> a legal, regulatory, tax, compliance, accounting, or government advisory service. We do not provide professional advice of any kind.</p>
      </LegalBlock>

      <LegalBlock num="2" heading="User Responsibility">
        <p>You are solely responsible for:</p>
        <ul className="space-y-2">
          <Li>Maintaining accurate renewal information in your account.</Li>
          <Li>Verifying renewal dates, requirements, licenses, permits, insurance policies, certificates, contracts, and any compliance obligations directly with the relevant authorities, regulators, insurers, or counterparties.</Li>
          <Li>Acting on your renewals before they expire — RenewTracker does not act on your behalf.</Li>
        </ul>
      </LegalBlock>

      <LegalBlock num="3" heading="Service Availability">
        <p>RenewTracker does not guarantee uninterrupted service. The Service may be temporarily unavailable due to maintenance, upgrades, outages, or events outside our control.</p>
      </LegalBlock>

      <LegalBlock num="4" heading="Notifications">
        <p>RenewTracker does not guarantee delivery of email notifications or push notifications. Notification delivery may be affected by, among other things:</p>
        <ul className="space-y-2">
          <Li>Internet connectivity</Li>
          <Li>Device settings (notification permissions, battery savers, Do Not Disturb)</Li>
          <Li>Operating system restrictions or background-task limits</Li>
          <Li>Third-party providers (Firebase, Apple Push, Resend, your email host, your ISP)</Li>
          <Li>Spam filters and email-routing rules</Li>
          <Li>User actions such as muting, uninstalling, or blocking the app</Li>
          <Li>Technical failures, including those of our own systems</Li>
        </ul>
        <p>Reminders are provided as a convenience feature. You remain responsible for monitoring and verifying your renewal obligations.</p>
      </LegalBlock>

      <LegalBlock num="5" heading="Limitation of Liability">
        <p>To the maximum extent permitted by law, RenewTracker shall not be liable for any penalties, fines, missed renewals, business losses, legal claims, regulatory actions, revenue loss, indirect damages, or consequential damages arising from your use of, or inability to use, the Service.</p>
        <p>The maximum aggregate liability of RenewTracker, its owners, operators, developers, employees, contractors, and affiliates shall be limited to the amount you paid for the Service during the twelve (12) months immediately preceding the event giving rise to the claim.</p>
        <p className="italic text-slate-500">You use the Service at your own risk.</p>
      </LegalBlock>

      <LegalBlock num="6" heading="No Government Affiliation">
        <p>RenewTracker is an independent software platform and is not affiliated with, endorsed by, or connected to any government authority, licensing authority, insurance authority, regulatory body, or certification agency.</p>
      </LegalBlock>

      <LegalBlock num="7" heading="Account & Acceptable Use">
        <p>You agree to provide accurate registration information, keep your password confidential, and not use the Service for unlawful purposes or to harm other users or third parties.</p>
      </LegalBlock>

      <LegalBlock num="8" heading="Plans and Trials">
        <p>New accounts begin with a 14-day Premium trial. After the trial ends, the account moves to the Free plan. Existing data is preserved, but plan limits apply. Pricing for paid plans is shown inside the app and may change with notice.</p>
      </LegalBlock>

      <LegalBlock num="9" heading="Termination">
        <p>You may delete your account at any time from Settings. We may suspend or terminate access for conduct that violates these Terms or harms the Service. Upon termination, your data may be deleted as described in the Privacy Policy.</p>
      </LegalBlock>

      <LegalBlock num="10" heading="Changes to These Terms">
        <p>We may update these Terms from time to time. Material changes will be notified in-app or via email. Continued use of the Service after changes take effect constitutes acceptance.</p>
      </LegalBlock>

      <LegalBlock num="11" heading="Contact">
        <p>Questions about these Terms? Contact us at <Email />.</p>
      </LegalBlock>
    </LegalLayout>
  );
}
